exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".uhe-dropzone .filepond--item {\n  width: calc(20% - 0.5em);\n}", ""]);

